import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-270690ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, "*请确保操作员持有有效的农业无人机操作证，否则出险会被保司拒赔！", -1))
const _hoisted_3 = { class: "operator-list-content" }
const _hoisted_4 = { class: "operator-list-wrap" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "info" }
const _hoisted_7 = { class: "name" }
const _hoisted_8 = { class: "phone" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-arrow-right-svg" }, null, -1))
const _hoisted_10 = { class: "form-content" }
const _hoisted_11 = { class: "form-wrap" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "操作员姓名", -1))
const _hoisted_13 = { class: "value" }
const _hoisted_14 = { class: "van-hairline--top" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "操作员身份证", -1))
const _hoisted_16 = { class: "value" }
const _hoisted_17 = { class: "van-hairline--top" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "手机号", -1))
const _hoisted_19 = { class: "value" }

import { useStore } from 'vuex'
import { v4 as uuidv4 } from 'uuid'
import { Button, Field } from 'vant'
import { useRouter, useRoute } from 'vue-router'
import { serviceItem } from '@/types/three-liability-insurance'
import { modifyOperator } from '@/apis/three-liability-insurance'
import { OperatorItemType } from '@/types/three-liability-insurance'
import { showNormalToast, showConfirmModal, showToastLoading, showToastFail } from '@/utils/tools'
import { computed, onMounted, reactive, ref, Ref, withDefaults } from 'vue'
import { InsuranceThirdPartyDronePingan2024DataStorage } from '@/storage/insurance'
import AppHeader from '@/components/Header.vue'
import CommonFooterWrap from '@/components/CommonFooterWrap.vue'
import PopupCommonWrap from '@/components/popup/common-wrap.vue'
import { commonErrorHandle } from '@/utils/error-handle'


export default /*#__PURE__*/_defineComponent({
  __name: 'pingan2024-operator',
  props: {
    displayMode: { default: 'Portrait' }
  },
  setup(__props: any) {

const props = __props as { displayMode: string };


const $router = useRouter()
const sn = useRoute().query.sn as string
const store = useStore()
const updated_by = store.state.userInfo.realName
const operatorList: Ref<OperatorItemType[]> = ref([])
const mode = ref('add')
const showPopup = ref(false)
const serviceDetail: Ref<serviceItem | null> = ref(null)

const isAdd = computed(() => {
  return mode.value === 'add'
})
const popupTitle = computed(() => {
  return `${isAdd.value ? '新增' : '修改'}操作员`
})
const formValue = reactive({
  name: '',
  phone: '',
  id_card: '',
  uuid: '',
  old_id_card: '',
})

function resetFormValue() {
  formValue.name = ''
  formValue.phone = ''
  formValue.id_card = ''
}
// 添加操作员前
function beforeAddHandle() {
  showPopup.value = true
  mode.value = 'add'
  resetFormValue()
}
// 编辑操作员前
function beforeEditOperator(item: OperatorItemType) {
  showPopup.value = true
  mode.value = 'edit'
  formValue.name = item.name
  formValue.phone = item.phone
  formValue.id_card = item.id_card
  formValue.uuid = item.uuid
  formValue.old_id_card = item.old_id_card
}
// 参数验证
function paramsVerfiy() {
  // eslint-disable-next-line camelcase
  const { id_card, name, phone, uuid } = formValue
  let message = ''
  if (!name) {
    message = '请输入操作员姓名'
    // eslint-disable-next-line camelcase
  } else if (!id_card) {
    message = '请输入操作员身份证'
  } else if (
    isAdd.value &&
    operatorList.value
      .filter((item) => item.uuid === uuid)
      .some((item) => item.id_card.trim() === id_card.trim())
  ) {
    message = '身份证重复'
  } else if (!phone) {
    message = '请输入操作员手机号'
  }
  if (message) {
    showNormalToast(message)
    return false
  }
  return true
}
// 接口提交
async function sumbitHandle(operator_list: OperatorItemType[]) {
  try {
    const data = await modifyOperator({
      policy_no: serviceDetail.value?.policy_no,
      updated_by,
      operator_list,
    })
    console.log('data', data)
    if (data.status === 400) {
      showToastFail(data.message)
      return Promise.reject(new Error(data.message))
    }
  } catch (error) {
    commonErrorHandle(error)
    return Promise.reject(error)
  }
}
// 删除操作员
async function removeHandle() {
  const uuid = formValue.uuid
  try {
    await showConfirmModal({ title: '确认是否删除该操作员？' })
  } catch (error) {
    console.log('error', error)
  }
  const operator_list = operatorList.value.map((item) => ({
    ...item,
    status: item.uuid === uuid ? 'D' : 'U',
  }))
  showToastLoading()
  try {
    const data = await sumbitHandle(operator_list)
    showNormalToast('删除成功')
    showPopup.value = false
    operatorList.value = operatorList.value.filter((item) => item.uuid !== uuid)
  } catch (error) {
    commonErrorHandle(error)
  }
  updateCacheValue()
}
// 确认保存
async function confirmSave() {
  if (!paramsVerfiy()) {
    return
  }
  const operator_list = isAdd.value
    ? operatorList.value.concat({
        name: formValue.name,
        phone: formValue.phone,
        id_card: formValue.id_card,
        old_id_card: '',
        status: 'A',
        uuid: uuidv4(),
      })
    : operatorList.value.map((item) => {
        let result = {
          ...item,
        }
        if (item.uuid === formValue.uuid) {
          result = {
            ...result,
            ...formValue,
          }
        }
        return result
      })
  showToastLoading()
  try {
    const data = await sumbitHandle(operator_list)
    console.log('data', data)
    showNormalToast(isAdd.value ? '新增成功' : '更新成功')
    showPopup.value = false
    operatorList.value = operator_list.map((item) => ({
      ...item,
      status: 'U', // 全部重置为U
      old_id_card: item.old_id_card || item.id_card, // 新增的时候需要重置为最新的身份证号
    }))
    updateCacheValue()
  } catch (error) {
    console.log('error', error)
  }
}
// 更新缓存
function updateCacheValue() {
  sessionStorage.removeItem('printGAC' + sn) // 清除保单缓存
  sessionStorage.setItem('needUpdatePinganVoucherUrl', '1')
  const oldData = serviceDetail.value
  oldData.operator = JSON.stringify(operatorList.value)
  InsuranceThirdPartyDronePingan2024DataStorage.set(oldData)
}
// 返回
function backHandle() {
  $router.go(-1)
}
onMounted(() => {
  const data = InsuranceThirdPartyDronePingan2024DataStorage.get<serviceItem>()
  serviceDetail.value = data
  try {
    const formatOperatorList = JSON.parse(data.operator)
    operatorList.value =
      formatOperatorList?.map((item: OperatorItemType) => ({
        uuid: uuidv4(),
        name: item.name,
        phone: item.phone,
        status: 'U',
        id_card: item.id_card,
        old_id_card: item.id_card,
      })) || []
  } catch (error) {
    console.log('error', error)
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "操作员" }),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("ul", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(operatorList.value, (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              class: _normalizeClass(index > 0 ? 'van-hairline--top' : ''),
              onClick: ($event: any) => (beforeEditOperator(item))
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(item.name), 1),
                _createElementVNode("div", _hoisted_8, _toDisplayString(item.phone), 1)
              ]),
              _hoisted_9
            ], 10, _hoisted_5))
          }), 128))
        ])
      ]),
      _createVNode(CommonFooterWrap, { class: "button-wrap" }, {
        default: _withCtx(() => [
          _createVNode(_unref(Button), {
            class: "reback",
            onClick: backHandle
          }, {
            default: _withCtx(() => [
              _createTextVNode("返回")
            ]),
            _: 1
          }),
          _createVNode(_unref(Button), {
            class: "next-button xa-vant-button",
            round: "",
            onClick: beforeAddHandle,
            disabled: operatorList.value.length > 20
          }, {
            default: _withCtx(() => [
              _createTextVNode("新增操作员")
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _: 1
      }),
      _createVNode(PopupCommonWrap, {
        title: _unref(popupTitle),
        show: showPopup.value,
        "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((showPopup).value = $event)),
        teleport: "body"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("ul", _hoisted_11, [
              _createElementVNode("li", null, [
                _hoisted_12,
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_unref(Field), {
                    modelValue: formValue.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formValue.name) = $event)),
                    class: "cell-field",
                    placeholder: "必填，请与操作员证件姓名一致"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("li", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_unref(Field), {
                    modelValue: formValue.id_card,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formValue.id_card) = $event)),
                    class: "cell-field",
                    placeholder: "必填，请正确填写操作员的证件号"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("li", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_unref(Field), {
                    modelValue: formValue.phone,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formValue.phone) = $event)),
                    class: "cell-field",
                    placeholder: "必填，请正确填写操作员的手机号"
                  }, null, 8, ["modelValue"])
                ])
              ])
            ])
          ]),
          _createVNode(CommonFooterWrap, { class: "button-wrap form-button" }, {
            default: _withCtx(() => [
              (!_unref(isAdd))
                ? (_openBlock(), _createBlock(_unref(Button), {
                    key: 0,
                    class: "reback delete-button",
                    onClick: removeHandle
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("删除")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_unref(Button), {
                class: "next-button xa-vant-button",
                round: "",
                onClick: confirmSave
              }, {
                default: _withCtx(() => [
                  _createTextVNode("保存")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["title", "show"])
    ])
  ], 64))
}
}

})